import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { clearAppointments, filterAppointments, setDate, showAllBarberFilters } from './actions';
import viewsConfig from './config';
import barberConfig from '../../barber/config';
import BarbersFilter from './barbersFilter/barbersFilterContainer';
import StatusFilter from './statusFilter/statusFilter';
import DatePicker from './datePicker/datePicker';
import ViewOptions from './viewOptions/viewOptions';
import {
  getFilters,
  getDate,
} from './appointmentSelector';
import {
  getStartOfDay,
} from '../../common/helpers/times';
import * as selector from '../barbers/selector';
import config from '../../../config';
import { USER_TYPES } from '../../auth/constants';
import RoleAware from '../../auth/roleAware';
import {
  canUserViewAppointmentHistory,
} from '../../common/helpers/users';
import { containerApp } from '../../../main';

class AppointmentNavigator extends Component {

  componentWillMount() {
    const { currentDate, currentView, timezone } = this.props;
    let date = currentDate || this.getToday();
    if (currentView === 'list') {
      const selectedDayStart = getStartOfDay(timezone, date);
      const todayStart = getStartOfDay(timezone);
      if (selectedDayStart.isSameOrBefore(todayStart, 'day')) {
        date = this.getToday();
      }
    }
    this.updateDate(date);

    this.props.showAllBarbers();
  }

  componentDidUpdate() {
    if (!this.props.currentDate) {
      this.updateDate(this.getToday());
    }
  }

  getToday() {
    return getStartOfDay(this.props.timezone).format(config.dateFormatISO);
  }

  changeDate = (newDate = null) => {
    const date = newDate || this.getToday();
    if (date !== this.props.currentDate) {
      this.updateDate(date);
    }
  }

  updateDate = (date) => {
    this.props.setDate(date);
  }

  filterAppointments(params) {
    const {
      statusFilter,
    } = {
      ...this.props,
      ...params,
    };

    const filters = {};

    // TODO: rewrite this condition if it is possible
    if ((statusFilter && parseInt(statusFilter.status__in, 10) === 0) || statusFilter === '0') {
      filters.status__in = statusFilter;
    }

    this.props.filterAppointments(filters);
  }

  updateStatusFilter = (e) => {
    const status = e.target.checked ? '0' : null;
    this.filterAppointments({
      statusFilter: status,
    });
  }

  renderViewOptions = (barbers, currentView) => {
    const config = this.props.user.kind === USER_TYPES.barber ? barberConfig : viewsConfig;
    return (
      <div className="o-flexbox">
        <ViewOptions
          config={config}
          currentView={currentView}
          onOptionClick={this.props.clearAppointments}
        />
        <RoleAware deny={USER_TYPES.barber}>
          <StatusFilter
            updateStatusFilter={this.updateStatusFilter}
            currentView={currentView}
          />
        </RoleAware>
        <RoleAware deny={USER_TYPES.barber}>
          <BarbersFilter currentView={currentView} />
        </RoleAware>
        {this.props.additionalButtons}
      </div>
    );
  }

  render() {
    const {
      barbers,
      currentDate,
      currentView,
      timezone,
      permissions,
    } = this.props;
    const pastDateLimit = !canUserViewAppointmentHistory(permissions) ? this.getToday() : '';

    return (
      <div className="o-flexbox c-wrapper">
        <div className="o-flexbox__item large-and-down-mb">
          {!containerApp.isActive() && this.renderViewOptions(barbers, currentView)}
        </div>
        <DatePicker
          startDate={pastDateLimit}
          currentDate={currentDate}
          currentView={currentView}
          changeDate={this.changeDate}
          timezone={timezone}
          today={this.getToday()}
        />
      </div>
    );
  }
}

AppointmentNavigator.propTypes = {
  timezone: PropTypes.string.isRequired,
  filterAppointments: PropTypes.func.isRequired,
  setDate: PropTypes.func.isRequired,
  barbers: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentDate: PropTypes.string.isRequired,
  currentView: PropTypes.string.isRequired,
  statusFilter: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  additionalButtons: PropTypes.node,
  showAllBarbers: PropTypes.func.isRequired,
  clearAppointments: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  barbers: selector.getAll(state),
  timezone: state.auth.timezone,
  pubnubChange: state.main.pubnub_change,
  currentDate: getDate(state),
  statusFilter: getFilters(state),
  user: state.auth.user,
  permissions: state.auth.permissions,
});

const mapDispatchToProps = {
  filterAppointments,
  setDate,
  showAllBarberFilters,
  clearAppointments,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    showAllBarbers: props => () => props.barbers && props.showAllBarberFilters(props.barbers),
  }),
)(AppointmentNavigator);
